export default "__VITE_ASSET__1653b12d__"